import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { RightPanelProps } from './RightPanel.tsx';

const createLoadingComponent = () => {
	return UFOLoadHold({
		name: 'LoadingConfluenceRightPanelBundle',
	});
};
export const PanelLoader: LoadableType<RightPanelProps> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RightPanel" */ './RightPanel.tsx')).RightPanel,
	loading: createLoadingComponent,
});
